import { render } from "./HFarguadd.vue?vue&type=template&id=2f16d334&scoped=true"
import script from "./HFarguadd.vue?vue&type=script&lang=js"
export * from "./HFarguadd.vue?vue&type=script&lang=js"

import "./HFarguadd.vue?vue&type=style&index=0&id=2f16d334&lang=scss&scoped=true"
import "./HFarguadd.vue?vue&type=style&index=1&id=2f16d334&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f16d334"]])

export default __exports__